import "./newroom.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import { useState } from "react";
import { collection, addDoc, setDoc, doc, serverTimestamp } from "firebase/firestore"; 
import {db} from "../../firebase"
import { Navigate, useNavigate } from "react-router";

const Edit = ({ inputs, title }) => {
  const [room, setRoom] = useState ("")
  const[data, setData] = useState({})
  const navigate = useNavigate()
  
  const handleInput = (e) =>{
    const id = e.target.id
    const value = e.target.value

    setData({...data, [id]: value})
  }
  console.log(data)
  

  

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const res = await addDoc(collection(db, "rooms"), {
        name:data.name,
        price:data.price,
        // status: ,
        timeStamp: serverTimestamp()
      });
      console.log(res)
      // await NewRoom(data)

    } catch (err) {
      console.log(err)
    }
    
      
      
      navigate(-1)
    } 

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>Update the Room Information</h1>
        </div>
        <div className="bottom">
          
          <div className="right">
            {/* <form onSubmit={handleAdd}> */}
            <form onSubmit={handleUpdate}>
              

              {inputs((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input 
                    id={input.id}
                    type={input.type} 
                    placeholder={input.placeholder} 
                    value={input.value} 
                    onChange={handleInput}
                  />
                </div>
              ))}
              <button type="submit">Update</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
